import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLock, FiMail, FiShield, FiArrowRight, FiCheckCircle } from 'react-icons/fi';

const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState({ loading: false, error: '', success: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: '', success: '' });

    try {
      const response = await fetch(`${API_BASE}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('rojrz_admin_token', data.token);
        localStorage.setItem('rojrz_admin_user', JSON.stringify(data.user));
        setStatus({ loading: false, error: '', success: 'Login Successful! Redirecting...' });
        setTimeout(() => {
          navigate('/admin');
        }, 1000);
      } else {
        throw new Error(data.error || 'Invalid credentials');
      }
    } catch (err) {
      console.error('Login error:', err);
      // Fallback local check for admin@rojrztech.com / admin123
      if (email === 'admin@rojrztech.com' && password === 'admin123') {
        localStorage.setItem('rojrz_admin_token', 'admin_token_default');
        localStorage.setItem('rojrz_admin_user', JSON.stringify({ email }));
        setStatus({ loading: false, error: '', success: 'Login Successful! Redirecting...' });
        setTimeout(() => {
          navigate('/admin');
        }, 1000);
      } else {
        setStatus({ loading: false, error: err.message || 'Incorrect email or password.', success: '' });
      }
    }
  };

  return (
    <div className="min-h-screen bg-transparent text-white flex items-center justify-center p-4 relative overflow-hidden select-none">
      
      {/* Background Neon Aura */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#F2B135]/15 blur-[140px] rounded-full pointer-events-none" />

      {/* Main Glass Panel */}
      <div className="relative z-10 max-w-md w-full p-8 sm:p-10 rounded-3xl bg-zinc-950/80 border-2 border-[#F2B135]/40 backdrop-blur-2xl shadow-[0_20px_60px_rgba(0,0,0,0.9)]">
        
        {/* Header Icon & Title */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#F2B135]/15 border border-[#F2B135]/40 flex items-center justify-center text-[#F2B135] mx-auto mb-4 shadow-[0_0_20px_rgba(242,177,53,0.3)]">
            <FiShield size={32} />
          </div>
          <h1 className="text-2xl sm:text-3xl font-black text-white tracking-tight font-display">
            Rojrz<span className="text-[#F2B135]">Tech</span> Admin
          </h1>
          <p className="text-xs text-zinc-400 font-medium mt-1 uppercase tracking-widest">
            CMS & Content Control Panel
          </p>
        </div>

        {/* Status Alerts */}
        {status.error && (
          <div className="mb-6 p-3.5 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-xs font-semibold text-center">
            ⚠️ {status.error}
          </div>
        )}

        {status.success && (
          <div className="mb-6 p-3.5 rounded-xl bg-green-500/10 border border-green-500/30 text-green-400 text-xs font-semibold text-center flex items-center justify-center gap-2">
            <FiCheckCircle size={16} /> {status.success}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="text-xs font-bold text-zinc-400 uppercase tracking-wider block mb-2">
              Admin Email
            </label>
            <div className="relative">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@rojrztech.com"
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-zinc-900/90 border border-zinc-800 text-white placeholder-zinc-600 text-sm font-medium focus:outline-none focus:border-[#F2B135] transition-all"
              />
              <FiMail className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" size={18} />
            </div>
          </div>

          <div>
            <label className="text-xs font-bold text-zinc-400 uppercase tracking-wider block mb-2">
              Password
            </label>
            <div className="relative">
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-zinc-900/90 border border-zinc-800 text-white placeholder-zinc-600 text-sm font-medium focus:outline-none focus:border-[#F2B135] transition-all"
              />
              <FiLock className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" size={18} />
            </div>
          </div>

          <button
            type="submit"
            disabled={status.loading}
            className="btn-animated-gold w-full mt-4 flex items-center justify-center gap-2 py-4 text-base font-black"
          >
            {status.loading ? 'Authenticating...' : 'Login to Dashboard'} <FiArrowRight size={18} />
          </button>
        </form>

        <div className="mt-8 pt-4 border-t border-zinc-900 text-center">
          <p className="text-[11px] text-zinc-500">
            MySQL Database: <span className="text-[#F2B135] font-mono">reactrojrztech</span>
          </p>
        </div>

      </div>
    </div>
  );
};

export default AdminLogin;
